import React from "react";
import { FadeUp } from "../motion/Reveal";
import { Quote } from "lucide-react";

const TESTIMONIALS = [
    {
        quote:
            "A GreenDuck entregou em 8 semanas o que outra fábrica não conseguiu em 6 meses. Nosso app de investimentos saltou de zero a R$4M movimentados no primeiro mês.",
        author: "Marina Cortez",
        role: "CPO · Fintech Aurora",
    },
    {
        quote:
            "Tratam o problema de negócio antes do código. Isso mudou completamente nossa operação — economizamos 40h/mês por médico com o copilot que eles construíram.",
        author: "Dr. Eduardo Mansur",
        role: "CEO · MediCore",
    },
    {
        quote:
            "Design impecável, engenharia sólida e um time que não some depois do deploy. Único fornecedor de tech que virou parceiro estratégico do board.",
        author: "Camila Reis",
        role: "COO · Vertex Retail",
    },
];

export default function Testimonials() {
    return (
        <section
            className="relative py-32 md:py-40 border-b border-white/10 bg-[#080808]"
            data-testid="testimonials-section"
        >
            <div className="max-w-[1600px] mx-auto px-6 md:px-10">
                <FadeUp>
                    <span className="font-mono-tech text-xs tracking-widest text-[#00FF66] uppercase">
                        (Provas sociais)
                    </span>
                    <h2 className="mt-4 font-display uppercase text-5xl md:text-7xl leading-[0.95] tracking-tighter text-white max-w-3xl mb-16">
                        Clientes que
                        <br />
                        <span className="text-white/40">viraram</span>
                        <span className="text-[#00FF66]"> torcida.</span>
                    </h2>
                </FadeUp>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
                    {TESTIMONIALS.map((t, i) => (
                        <FadeUp key={i} delay={i * 0.1}>
                            <blockquote
                                className="border border-white/10 bg-[#0a0a0a] p-8 md:p-10 clip-frame-sm h-full flex flex-col justify-between min-h-[360px]"
                                data-testid={`testimonial-${i}`}
                            >
                                <Quote
                                    className="w-8 h-8 text-[#00FF66] mb-6"
                                    strokeWidth={1.5}
                                />
                                <p className="text-white/85 text-lg leading-relaxed mb-8">
                                    {t.quote}
                                </p>
                                <footer className="border-t border-white/10 pt-6">
                                    <div className="font-display text-white text-lg">
                                        {t.author}
                                    </div>
                                    <div className="font-mono-tech text-xs text-white/50 uppercase mt-1">
                                        {t.role}
                                    </div>
                                </footer>
                            </blockquote>
                        </FadeUp>
                    ))}
                </div>
            </div>
        </section>
    );
}
